import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class SubMenuStateTogglerService {

	public toggle: EventEmitter<SubMenuStateEnum> = new EventEmitter<SubMenuStateEnum>();

	constructor() {
	}

}

export enum SubMenuStateEnum {
	menuOpen,
	menuClose,
	configOpen,
	configClose
}